/** @module                     Hooks */

import { usePagename }          from "../../Hooks/usePagename";

import { useTranslation }       from "react-i18next";

import { 
    
    useEffect, 
    
    useRef, 
    
    useState }                  from "react";

import useFetch                 from "../../Hooks/useFetch";

import { useParams }            from "react-router-dom";

/** @module                     Queries */

import { APPOINTMENT }          from "../../Queries/Montage";

/** @module                     Components */

import Breadcrumbs              from "../../Components/Dashboard/Breadcrumbs";

import AsideEdit                from "../../Components/Dashboard/Global/Layouts/Mutations/Aside";

import ComponentLoader          from "../../Components/Dashboard/Loaders/ComponentLoader";

import { LabeledInput }         from "../../Components/Dashboard/Global/Forms/Inputs";

import Fieldset                 from "../../Components/Dashboard/Global/Forms/Fieldset";

import Sidebar                  from "../../Components/Dashboard/Montage/Edit/Sidebar";

import Notice                   from "../../Components/Dashboard/Global/Notice";

/** @module                     Utilities */

import { disableAttribute }     from "../../Components/Dashboard/Utils/disableAttribute";
import useUpdateAppointment from "../../Hooks/Montage/useUpdateAppointment";
import useDeleteAppointment from "../../Hooks/Montage/useDeleteAppointment";

const 

/**
 * 
 * @param { String } name
 * 
 * @returns add appointment page component
 * 
 */

EditAppointment = ( { name } ) => { usePagename ( name ); const 

    /** @module         Hooks */

    { appointmentId }   = useParams (),

    { t }               = useTranslation (),

    { data, loading }   = useFetch ( APPOINTMENT, { id: appointmentId } );

    /** @returns */

    return ( <section className="mutations edit appointment">

        <Breadcrumbs data={ [

            { 
                
                name    : t ( "montage" ), 
                
                uri     : "/app/montage"       
            
            },

            { 
                
                name    : t ( name ), 
                
                uri     : `/app/montage/edit`    
            
            }

        ] } />

        { loading ? <ComponentLoader /> : <Component data={ data } __={ t } /> }

    </section> );

},

/**
 * 
 * 
 * @param { Function } __
 * 
 * @returns edit appointment page content component
 * 
 */

Component = ( { data, __ } ) => { const

    /** @module                 States */

    [ autoNumber,               setAutoNumber           ] = useState ( data.adminAppointment.autoNumber || "" ),

    [ autoBrand,                setAutoBrand            ] = useState ( data.adminAppointment.autoBrand || "" ),

    [ autoModel,                setAutoModel            ] = useState ( data.adminAppointment.autoModel || "" ),

    [ fullName,                 setFullName             ] = useState (  data.adminAppointment.fullName || "" ),

    [ phoneNumber,              setPhoneNumber          ] = useState ( data.adminAppointment.phoneNumber || "" ),

    [ diskDiameter,             setDiskDiameter         ] = useState ( data.adminAppointment.diskDiameter || "" ),

    [ email,                    setEmail                ] = useState ( data.adminAppointment.email || "" ),

    [ notes,                    setNotes                ] = useState ( data.adminAppointment.notes || "" ),

    [ transportType,            setTransportType        ] = useState ( data.adminAppointment.transportType || "" ),

    [ tiresStoredNotes,         setTiresStoredNotes     ] = useState ( data.adminAppointment.tiresBoughtNotes || "" ),

    [ tiresBoughtNotes,         setTiresBoughtNotes     ] = useState ( data.adminAppointment.tiresBoughtNotes || "" ),

    [ tiresStored,              setTiresStored          ] = useState ( data.adminAppointment.tiresStored || false ),

    [ tiresBought,              setTiresBought          ] = useState ( data.adminAppointment.tiresBought || false ),

    [ startTime,                setStartTime            ] = useState ( new Date ( data.adminAppointment.startTime ) ),

    [ endTime,                  setEndTime              ] = useState ( new Date ( data.adminAppointment.endTime ) ),

    [ year,                     setYear                 ] = useState ( new Date ( data.adminAppointment.startTime ).getFullYear () ),

    [ month,                    setMonth                ] = useState ( new Date ( data.adminAppointment.startTime ).getMonth () + 1 ),

    [ day,                      setDay                  ] = useState ( new Date ( data.adminAppointment.startTime ).getDate () ),

    [ time,                     setTime                 ] = useState ( "" ),

    /** @module                 References */

    autoNumberRef               = useRef ( null ),

    autoBrandRef                = useRef ( null ),

    autoModelRef                = useRef ( null ),

    fullNameRef                 = useRef ( null ),

    phoneNumberRef              = useRef ( null ),

    diskDiameterRef             = useRef ( null ),

    emailRef                    = useRef ( null ),

    notesRef                    = useRef ( null ),

    transportTypeRef            = useRef ( null ),

    tiresStoredNotesRef         = useRef ( null ),

    tiresBoughtNotesRef         = useRef ( null ),

    tiresStoredRef              = useRef ( null ),

    tiresBoughtRef              = useRef ( null ),

    startTimeRef                = useRef ( null ),

    endTimeRef                  = useRef ( null ),

    submitRef                   = useRef ( null ),

    removeRef                   = useRef ( null ),

    yearRef                     = useRef ( null ),

    monthRef                    = useRef ( null ),

    dayRef                      = useRef ( null ),

    timeRef                     = useRef ( null ),

    /** @module                 Hooks */

    { 
        
        updateAppointment, 
        
        loading, 
        
        errors,

        success
    
    } = useUpdateAppointment (),

    { deleteAppointment, loading : deleteLoading, errors : deleteErrors } = useDeleteAppointment (),

    /** @event onSubmit */

    submitAppointment = () => updateAppointment (

        data.adminAppointment.id,

        data.adminAppointment.startTime,

        data.adminAppointment.endTime,

        autoNumber,

        autoBrand,

        autoModel,

        fullName,

        phoneNumber,

        diskDiameter,

        email,

        notes,

        transportType,

        tiresStoredNotes,

        tiresBoughtNotes,

        tiresStored,

        tiresBought,

        startTime,

        endTime

    ),

    /** @event onDelete */

    submitRemoval = () => {

        deleteAppointment ( data.adminAppointment.id );

    };

    /** @event useEffect */

    useEffect ( () => {

        if ( loading ) {

            disableAttribute ( [ submitRef ], "add" );

            if ( submitRef.current ) {

                submitRef.current.innerHTML = `${ __ ( "submitting" ) }...`;

            }

        } else { 

            disableAttribute ( [ submitRef ], "remove" );

            if ( submitRef.current ) {

                submitRef.current.innerHTML = __ ( "submit" );

            }
    
        }

    }, [ loading ] );
    
    /** @returns */

    return ( 
    
        <AsideEdit aside={ 
        
            <Sidebar 
                
                details={ 
                    
                    {

                        dataPlaceholder : {

                            start: data.adminAppointment.startTime,

                            end: data.adminAppointment.endTime,

                            box: data.adminAppointment.boxName,

                        },

                        time : { 
                            
                            view        : time, 
                            
                            set         : setTime, 
                            
                            reference   : timeRef 
                        
                        },

                        year : { 
                            
                            view        : year, 
                            
                            set         : setYear, 
                            
                            reference   : yearRef 
                        
                        },

                        month : { 
                            
                            view        : month, 
                            
                            set         : setMonth, 
                            
                            reference   : monthRef 
                        
                        },

                        day : { 
                            
                            view        : day, 
                            
                            set         : setDay, 
                            
                            reference   : dayRef 
                        
                        },

                        transportType : { 
                            
                            view        : transportType, 
                            
                            set         : setTransportType, 
                            
                            reference   : transportTypeRef 
                        
                        },

                        tiresStored : { 
                            
                            view        : tiresStored, 
                            
                            set         : setTiresStored, 
                            
                            reference   : tiresStoredRef 
                        
                        },

                        tiresBought : { 
                            
                            view        : tiresBought, 
                            
                            set         : setTiresBought, 
                            
                            reference   : tiresBoughtRef 
                        
                        },

                        startTime : { 
                            
                            view        : startTime, 
                            
                            set         : setStartTime, 
                            
                            reference   : startTimeRef 
                        
                        },

                        endTime : { 
                            
                            view        : endTime, 
                            
                            set         : setEndTime, 
                            
                            reference   : endTimeRef 
                        
                        },

                        submit : { 
                            
                            reference   : submitRef, 
                            
                            action      : submitAppointment 
                        
                        },

                        remove : { 
                            
                            reference   : removeRef, 
                            
                            action      : submitRemoval 
                        
                        }
            
                    } 
            
                } 
            
            /> 
            
        }>

            { errors && <Notice type="danger">

                { __ ( "failed_save" ) }

            </Notice> }

            { deleteErrors && <Notice type="danger">

                { __ ( "failed_delete" ) }

            </Notice> }

            { success && <Notice type="success">

                { __ ( "save_success" ) }

            </Notice> }

            <Fieldset legend={ __ ( "vehicle_information" ) }>

                <LabeledInput

                    label={ __ ( "autoNumber" ) }
                    
                    value={ autoNumber }
        
                    action={ e => setAutoNumber ( e ) }
        
                    ref={ autoNumberRef }
                
                />

                <LabeledInput

                    label={ __ ( "autoBrand" ) }
                    
                    value={ autoBrand }
        
                    action={ e => setAutoBrand ( e ) }
        
                    ref={ autoBrandRef }
                
                />

                <LabeledInput

                    label={ __ ( "autoModel" ) }
                    
                    value={ autoModel }
        
                    action={ e => setAutoModel ( e ) }
        
                    ref={ autoModelRef }
                
                />

                <LabeledInput

                    ladel={ __ ( "diskDiameter" ) }
                    
                    value={ diskDiameter }
        
                    action={ e => setDiskDiameter ( e ) }
        
                    ref={ diskDiameterRef }
                
                />

            </Fieldset>

            <Fieldset legend={ __ ( "customer_information" ) }>

                <LabeledInput

                    label={ __ ( "fullName" ) }
                    
                    value={ fullName }
        
                    action={ e => setFullName ( e ) }
        
                    ref={ fullNameRef }
                
                />

                <LabeledInput

                    label={ __ ( "email" ) }
                    
                    value={ email }
        
                    action={ e => setEmail ( e ) }
        
                    ref={ emailRef }
                
                />

                <LabeledInput

                    label={ __ ( "phoneNumber" ) }

                    value={ phoneNumber }

                    action={ e => setPhoneNumber ( e ) }

                    ref={ phoneNumberRef }

                />

            </Fieldset>

            <Fieldset legend={ __ ( "notes" ) }>

                <LabeledInput

                    label={ __ ( "notes" ) }
                    
                    value={ notes }
        
                    action={ e => setNotes ( e ) }
        
                    ref={ notesRef }
                
                />

                <LabeledInput

                    label={ __ ( "tiresStoredNotes" ) }
                    
                    value={ tiresStoredNotes }
        
                    action={ e => setTiresStoredNotes ( e ) }
        
                    ref={ tiresStoredNotesRef }
                
                />

                <LabeledInput

                    label={ __ ( "tiresBoughtNotes" ) }

                    value={ tiresBoughtNotes }

                    action={ e => setTiresBoughtNotes ( e ) }

                    ref={ tiresBoughtNotesRef }

                />

            </Fieldset>
            
        </AsideEdit>  
        
    )

}
 
/** @exports EditAppointment */

export default EditAppointment;